import { VpcService } from '@inter-ikea-kompis/services';
import config from '../config';
/**
 * A @async function that takes one parameter.
 * Fetches the VPC configuration for the given id.
 *
 * @param vpcId
 */
export async function getConfigurationById(vpcId, serviceSettings) {
    const service = new VpcService({
        settings: serviceSettings,
        applicationName: config.paxApplicationName,
        dexfApiKey: config.dexfApiKey
    });
    const configurationId = vpcId;
    let configuration;
    try {
        const options = {
            includeIcfData: true
        };
        configuration = await service.getConfiguration(configurationId, options);
    }
    catch {
        // handle error
    }
    return configuration;
}
//# sourceMappingURL=vpc.js.map